export const initialState = {
  isOpen: false,
  isLoading: false,
};
